export default [
  {
    path: "/yunbuy",
    name: "yunbuy",
    meta: {
      title: "购买云手机",
      rightShow: true,
      unpull: true,
      noTop: true,
      noColor: true,
    },
    component: () => import("./YunBuy.vue"),
  },
  {
    path: "/juhui",
    name: "juhui",
    meta: {
      title: "首单钜惠",
      unpull: true,
      noTop: true,
      noColor: true,
    },
    component: () => import("./JuHui.vue"),
  },
  {
    path: "/yunxufei",
    name: "yunxufei",
    meta: {
      title: "选择续费设备",
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunXuFei.vue"),
  },
  {
    path: "/xufeibuy",
    name: "xufeibuy",
    meta: {
      title: "云手机续费",
    },
    component: () => import("./XuFeiBuy.vue"),
  },
  {
    path: "/yun/manage",
    name: "yun.manage",
    meta: {
      title: "管理云手机",
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunManage.vue"),
  },
  {
    path: "/yun/operation",
    name: "yun.operation",
    meta: {
      title: "批量操作",
      noheader: true,
      unpull: true,
    },
    component: () => import("./BulkOperation.vue"),
  },
  {
    path: "/change/yundevice",
    name: "change.yundevice",
    meta: {
      title: "更换设备",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./ChangeYunDevice.vue"),
  },
  {
    path: "/yun/setting",
    name: "yun.setting",
    meta: {
      title: "设置",
      noheader: true,
      unpull: true,
    },
    component: () => import("./YunSetting.vue"),
  },
  {
    path: "/wifi/tips",
    name: "wifi.tips",
    meta: {
      title: "非WIFI网络提示弹框",
      noheader: true,
      unpull: true,
    },
    component: () => import("./WifiPopTip.vue"),
  },
  {
    path: "/screenshot/clarity",
    name: "screenshot.clarity",
    meta: {
      title: "云手机预览截图清晰度",
      noheader: true,
      unpull: true,
    },
    component: () => import("./ScreenshotClarity.vue"),
  },
  {
    path: "/set/permission",
    name: "set.permission",
    meta: {
      title: "管理云手机权限",
      noheader: true,
      unpull: true,
    },
    component: () => import("./SetYunPermission.vue"),
  },
  {
    path: "/mike/permission",
    name: "mike.permission",
    meta: {
      title: "麦克风权限",
      noheader: true,
      unpull: true,
    },
    component: () => import("./MikePermissions.vue"),
  },
  {
    path: "/camera/permission",
    name: "camera.permission",
    meta: {
      title: "摄像头权限",
      noheader: true,
      unpull: true,
    },
    component: () => import(".//CameraPermissions.vue"),
  },
  {
    path: "/level/permission",
    name: "level.permission",
    meta: {
      title: "水平仪权限",
      noheader: true,
      unpull: true,
    },
    component: () => import(".//LevelPermissions.vue"),
  },
  {
    path: "/yunbuy/order",
    name: "order",
    meta: {
      title: "确认订单",
      unpull: true,
      noTop: true,
    },
    component: () => import("./YunOrder.vue"),
  },
  {
    path: "/yunbuy/pay",
    name: "pay",
    meta: {
      title: "订单支付",
    },
    component: () => import("./Pay.vue"),
  },
  {
    path: "/yunbuy/paysuccess",
    name: "paysuccess",
    meta: {
      title: "支付成功",
    },
    component: () => import("./PaySuccess.vue"),
  },
  {
    path: "/yun/clearphone",
    name: "yun.clearphone",
    meta: {
      title: "清理缓存",
    },
    component: () => import("./DeviceClean.vue"),
  },
];
